'use client';

import classnames from 'classnames';

import type { LoadingProps } from './Loading.types';
import { ReactComponent as LoadingIcon } from './icons/loading';

import styles from './Loading.module.scss';

function Loading({ style, className, testId = 'ui-loading' }: LoadingProps) {
  return (
    <div
      style={style}
      className={classnames(styles['loading'], className)}
      data-testid={testId}
    >
      <LoadingIcon
        className={styles['icon']}
        height="100%"
        width="100%"
        aria-label={'loading'}
      />
    </div>
  );
}

export { Loading };
